import { connect } from 'react-redux';
import Toast from './Toast';
import { getToastList } from '../../../store/selectors/general.selector';
import { removeToast } from '../../../store/actions/general.actions';

const mapStateToProps = (state) => {
  const toastList = getToastList(state);
  return {
    toastList,
  };
};

const mapStateToDispatch = {
  removeToast,
};

export default connect(mapStateToProps, mapStateToDispatch)(Toast);